// extracted by mini-css-extract-plugin
module.exports = {"formInput__label":"form-input-module--form-input__label--3CNn8","formInput":"form-input-module--form-input--f_7DL","formInput__input":"form-input-module--form-input__input--2HZNn"};